export default __webpack_public_path__ + "static/media/man.94fecd04.png";